/**
 * The merchant's Terms & Policies page: NeonCarts' own policies, which version
 * is in force and whether the business has accepted it. Conventions: see
 * `common.ts`.
 */
const legal: Record<string, string> = {
  title: 'Terms & Policies',
  intro:
    'The NeonCarts policies that apply to your business. They are set by NeonCarts and cannot be edited here; your own store policies live under Content › Pages.',
  'column.policy': 'Policy',
  'column.version': 'Version',
  'column.effective': 'Effective',
  'column.status': 'Status',
  'status.accepted': 'Accepted',
  'status.action_required': 'Action required',
  'status.not_required': 'For your information',
  accepted_on: 'Accepted v{version} on {date}',
  view: 'View',
  close: 'Close',
  accept: 'Accept',
  accepting: 'Saving…',
  accepted_notice: 'Thank you. Your acceptance of {name} has been recorded.',
  'pending.title': 'Some policies need your acceptance',
  'pending.body': 'Review the policies marked “Action required” and accept them to keep using NeonCarts.',
  'pending.staff':
    'Your business has not yet accepted every policy. Ask the business owner or an admin to review them.',
  'empty.title': 'No policies published yet',
  'empty.body': 'NeonCarts has not published any policies. Check back later.',
  load_error: 'We could not load the policies. Refresh the page to try again.',
  confirm_label: 'I have read and agree to the {name}, on behalf of my business.',
  open_new_tab: 'Open in a new tab',
};

export default legal;
